import {
  getAllSeminars,
  seminarAudience,
  seminarRazorpayOrders,
  seminarRegistrations,
  getWorkshopsById
} from '../api/v1/seminars';
import {
  FETCH_ALL_SEMINARS,
  SUBMIT_AUDIENCE,
  SET_ALERT_STATUS,
  SUBMIT_SEMINAR_RAZORPAY,
  SEMINAR_REGISTRATION,
  GET_WORKSHOP_BY_ID
} from '../constants/actionTypes';

export const fetchAllSeminars = () => (dispatch, start) => {
  start(FETCH_ALL_SEMINARS);
  return getAllSeminars().then(response => {
    return { value: response.data };
  });
};

export const fetchWorkshopsById = () => (dispatch, start) => {
  start(GET_WORKSHOP_BY_ID);
  return getWorkshopsById().then(response => {
    return { value: response.data };
  });
};

export const setAlertStatus = value => ({
  type: SET_ALERT_STATUS,
  payload: value
});

export const submitSeminarAudience = params => (dispatch, start) => {
  start(SUBMIT_AUDIENCE);
  return seminarAudience(params).then(res => {
    dispatch(setAlertStatus('success'));
    return res;
  });
};

export const submitSeminarRazorpayOrders = params => (dispatch, start) => {
  start(SUBMIT_SEMINAR_RAZORPAY);
  return seminarRazorpayOrders(params).then(res => {
    dispatch(setAlertStatus('success'));
    return res;
  });
};

export const seminarRegistration = params => (dispatch, start) => {
  start(SEMINAR_REGISTRATION);
  return seminarRegistrations(params).then(res => {
    dispatch(setAlertStatus('success'));
    return res;
  });
};



// WEBPACK FOOTER //
// ./src/actions/seminars.js